export default [
	{"text": "1-5 participantes",   "identifier": "5"},
	{"text": "5-10 participantes",  "identifier": "10"},
	{"text": "+10 participantes",   "identifier": "-1"}
];
